export const INITIAL_OTAR_EDIT_STATE = {
  "CONNECTION-ID": "",
  CreationDate: "",
  ModificationDate: "",
  "KMF-IPV4-ADDR": undefined,
  "KMF-PORT": undefined,
  "KMF-RADIO-SET-IDENTIFIER": undefined,
  "IWF-RADIO-SET-IDENTIFIER": undefined,
  "MESSAGE-NUMBER-PERIOD": undefined,
  "PRIVATE-CALL-SLN": undefined,
  "GROUP-REGROUP-SLN": undefined,
  "OTAR-REGISTRATION-TIMER": 8,
  "OPT-SEND-REKEY-REQ": false,
  "OPT-REVERSE-WARM-START": false,
  "OPT-DE-REGISTRATION": false,
  "OPT-HELLO-MAC-REPLY": false,
  "OPT-KEY-ASSIGNMENT": false,
  "KEEP-ALIVE-TIMER": undefined,
};

export const INITIAL_MCPTT_USERS_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "MCPTT-ID": "",
  "DISPLAY-NAME": "",
  "MAPPED-P25-ID": "",
  "MAPPED-DMR-ID": undefined,
  "MAPPED-ROIP-ID": undefined,
  "MAPPED-DFSI-ID": undefined,
  "MUTUAL-AID": false,
};

export const INITIAL_LMR_USERS_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "LMR-ID": "",
  "LMR-NW-TYPE": undefined,
  "MAPPED-MCPTT-ID": undefined,
  "MUTUAL-AID": false,
};

export const INITIAL_LMR_GROUPS_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "ORG-ID": undefined,
  "TG-ID": undefined,
  "LMR-NW-TYPE": undefined,
  "MAPPED-MCPTT-GID": undefined,
};

export const INITIAL_ORGANIZATION_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "ORG-ID": undefined,
  "ORG-NAME": undefined,
};

export const INITIAL_ORGANIZATION_PROFILE_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "UNIT-SECURITY": undefined,
  "UNIT-SLN": undefined,
  "DFSI-UNIT-CONTROL-ATTEMPT-LIMIT": undefined,
  "DFSI-UNIT-CONTROL-RETRY-TIME": undefined,
};

export const INITIAL_CANNED_MESSAGES_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "ORG-ID": undefined,
  "MSG-ID": undefined,
  "CANNED-TEXT": undefined,
};

export const INITIAL_LOCATION_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "IWF-ID": undefined,
  "IWF-LOCATION-NAME": undefined,
  "IWF-DOMAIN-NAME": undefined,
};

export const INITIAL_ORGANIZATION_MAPPING_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "IWF-ID": undefined,
  "ORG-ID": undefined,
};

export const INITIAL_ORGANIZATION_TRANSLATION_EDIT_STATE = {
  ID: undefined,
  FROM: undefined,
  EFI: false,
  EFO: false,
  TO: undefined,
};

export const INITIAL_DFSI_CONNECTION_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "CONNECTION-ID": undefined,
  "DFSI-VERSION": undefined,
  "IWF-ROLE": undefined,
  "HOST-CONTROL-IPV4-ADDR": undefined,
  "HOST-CONTROL-PORT": undefined,
  "HOST-VOICE-IPV4-ADDR": undefined,
  "VOICE-PORT": undefined,
  "DATA-IPV4-ADDR": undefined, // v2 only
  "DATA-PORT": undefined, // v2 only
  "FIXED-STATION-CONTROL-IPV4-ADDR": undefined,
  "FIXED-STATION-VOICE-IPV4-ADDR": undefined, // v1 only
  "FIXED-STATION-CONTROL-PORT": undefined,
  "CONNECTIVITY-TX-TIMER": undefined,
  "CONNECTIVITY-LOSS-LIMIT": undefined,
  "FS-HEARTBEAT-PERIOD": undefined, // v1 only
  "HOST-HEARTBEAT-PERIOD": undefined, // v1 only
  "CONTROL-RETRY-TIME": undefined,
  "CONTROL-ATTEMPT-LIMIT": undefined,
  "OUTBOUND-MAX-CAI-DATA-BLOCKS": undefined, // v2 only
  "INBOUND-MAX-CAI-DATA-BLOCKS": undefined, // v2 only
  "ACKNOWLEDGEMENT-DELAY": undefined,
  "INBOUND-REPEAT": true,
  "FIXED-STATION-VOTER-REPORTING-PERIOD": undefined,
  "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL": undefined,
};

export const INITIAL_CANNED_MESSAGE_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "ORG-ID": undefined,
  "MSG-ID": undefined,
  "CANNED-TEXT": undefined,
};

export const INITIAL_DFSI_CHANNEL_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "CONNECTION-ID": undefined,
  "CHANNEL-ID": undefined,
  "OUTBOUND-NETWORK-ACCESS-CODE": 659,
  "INBOUND-NETWORK-ACCESS-CODE": 659,
  "OTA-GROUP-ID": undefined,
  "CHANNEL-MODE": undefined,
  "CTC-SQUELCH-SYSTEM": undefined,
  "CDC-SQUELCH-SYSTEM": undefined,
};

export const INITIAL_DFSI_GROUP_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "DFSI-GROUP-NAME": undefined,
  "IWF-ID": undefined,
  "CHANNEL-IDS": undefined,
  "DFSI-LOGICAL-GID": undefined,
  "ENCRYPTION-ENABLED": undefined,
  SLN: undefined,
};

export const INITIAL_LMR_GROUP_PROFILE_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "GROUP-ACCESS-PERMISSION": undefined,
  "GROUP-EMERGENCY-CAPABLE": undefined,
  "GROUP-CC-SETUP-TIME": undefined,
  "GROUP-SECURITY": undefined,
  "GROUP-RFSS-ID": undefined,
  "GROUP-SLN": undefined,
};

export const INITIAL_MCPTT_GROUPS_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "MAPPED-P25-TG-ID": undefined,
  "MAPPED-DFSI-TG-ID": undefined,
  "MAPPED-DMR-TG-ID": undefined,
  "MAPPED-ROIP-TG-ID": undefined,
};

export const INITIAL_MCPTT_GROUP_PROFILE_EDIT_STATE = {
  CreationDate: "",
  ModificationDate: "",
  "GROUP-ACCESS-PERMISSION": undefined,
  "GROUP-PRIORITY": undefined,
  "GROUP-CC-SETUP-TIME": undefined,
  "GROUP-SECURITY": undefined,
  "GROUP-SLN": undefined,
  "GROUP-EMERGENCY-CAPABLE": undefined,
  "GROUP-EMERGENCY-PREEMPTION": undefined,
  "GROUP-RF-HANG-TIME": undefined,
  "GROUP-INTERRUPT-MODE": undefined,
  "GROUP-EXPIRATION-PERIOD": undefined,
};

export const INITIAL_IKI_EDIT_STATE = {
  "CONNECTION-ID": "",
  CreationDate: "",
  ModificationDate: "",
  "IKI-IPV4-ADDR": "",
  "IKI-PORT": undefined,
  "IKI-RADIO-SET-IDENTIFIER": undefined,
  "IWF-RADIO-SET-IDENTIFIER": undefined,
  "IKI-NAME": "",
  "IKI-CERTIFICATE": "",
};
